import { Event, EventContext, WebVitalsContext } from '@/modules/tracking/types'
import router from '@/router'
import { Metric } from 'web-vitals'

const pathRegex =
  /\/products\/|\/collections\/|\/company\/employees\/|\/cart\/checkout\/|\/quotes\/|\/cto\/modelconfiguration\/|\/cto\/modelgroup\/|\/login\/registration\/|\/login\/reset\//

export function getIframeUrl() {
  if (window.self !== window.top) {
    return document.referrer
  } else {
    return undefined
  }
}

const createEventContext = (event: Event): EventContext => {
  return {
    event,
    path: router.currentRoute.value.path,
    userAgent: window.navigator.userAgent,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width,
    iframeUrl: getIframeUrl()
  }
}

const createWebVitalsContext = (metric: Metric): WebVitalsContext => {
  return {
    webVitalsMetric: metric,
    path: removeSpecificSubPageFromPath(router.currentRoute.value.path),
    userAgent: window.navigator.userAgent,
    screenHeight: window.screen.height,
    screenWidth: window.screen.width
  }
}

const slicePath = (path: string, index: number, appendLastSegment: boolean): string => {
  const lastSlashIndex = path.lastIndexOf('/')
  if (appendLastSegment) {
    return path.slice(0, index + 1) + path.slice(lastSlashIndex + 1, path.length)
  } else {
    if (lastSlashIndex > index) {
      index = lastSlashIndex
    }
    return path.slice(0, index + 1)
  }
}

const findAndSlicePath = (
  path: string,
  regex: RegExp,
  appendLastSegment: boolean = false
): string | undefined => {
  const matchResult = regex.exec(path)
  if (matchResult?.index !== undefined) {
    for (let i = matchResult.index + 1; i < path.length; i++) {
      if (path[i] === '/') {
        return slicePath(path, i, appendLastSegment)
      }
    }
  }
  return undefined
}

const removeSpecificSubPageFromPath = (path: string): string => {
  // Extra case for quote checkout
  const quoteCheckout = findAndSlicePath(path, /\/quotes\/.+\/checkout/, true)
  if (quoteCheckout) return quoteCheckout

  // Extra case for orders
  const orders = findAndSlicePath(path, /\/orders\/.+\//, true)
  if (orders) return orders

  // General case
  const general = findAndSlicePath(path, pathRegex, false)
  if (general) return general

  return path
}

export { createEventContext, createWebVitalsContext }
